import type { Ref } from 'vue';
import { getMonitorList } from '@/service/Monitor';
import { IMonitor } from '@/service/Monitor/type';
import { ref } from 'vue';

// 获取监控数据
export const useMonitorList = (): [
  Ref<IMonitor>,
  Ref<boolean>,
  () => Promise<void>
] => {
  const loading = ref(true);
  const monitorData = ref<IMonitor>({
    recordList: [],
    appKey: '',
    accessToken: ''
  });
  // 获取监控数据
  const getMonitorListAsync = async () => {
    try {
      loading.value = true;
      const res = await getMonitorList();
      const data = res.data;
      monitorData.value = data;
      loading.value = false;
    } catch (error) {
      loading.value = false;
      console.log(error);
    } finally {
      // console.log('finally');
    }
  };

  return [monitorData, loading, getMonitorListAsync];
};
